export const RECEIVE_AUTH_REQUEST = 'RECEIVE_AUTH_REQUEST';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
